export default "__VITE_ASSET__OLOW7m2w__"